/*! Agile Pixel https://agilepixel.io - 2021*/
export default {
  init(selector) {
    const burgerButtons = document.querySelectorAll('.js-burger');
    const aside = document.querySelector('.js-aside');
    const header = document.querySelector('.js-header');

    selector.addEventListener('click', function (event) {
      event.preventDefault();

      if (aside.classList.contains('is-active')) {
        aside.classList.remove('is-active');
        header.classList.remove('is-burger');
      } else {
        aside.classList.add('is-active');
        header.classList.add('is-burger');
      }

      for (const burgerButton of burgerButtons) {
        if (burgerButton.classList.contains('is-active')) {
          burgerButton.classList.remove('is-active');
        } else {
          burgerButton.classList.add('is-active');
        }
      }
    });
  },
};
